import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
// import { OrderHistoryColumns } from '../../../Data/MockTable/TableHeaderList';
import SweetAlert from "sweetalert2";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import {
  getpackageselect,
  getPaymentDueSubscription,
} from "../../../CommonURL";
import { getDataWithToken } from "../../../Utils/restUtils";
import { Add } from "../../../Constant";
import DatePicker from "react-datepicker";
import SearchList from "../../../CommonElements/Search";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import CompanyFilter from "../../Common/Filters/CompanyFilter";
import Transparentspinner from '../../Common/loader/Transparentspinner';

const PaymentDueSubscriptionTable = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const [subscriptionList, setSubscriptionList] = useState([]);
  // const [accountData, setAccountData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  // const [tempSearch, setTempSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [isIndustry, setIsIndustry] = useState("");
  const [packageOptions, setPackageOptions] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [isCompany, setIsCompany] = useState("");
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [dateRange, setDateRange] = useState([
    //   filters.start_date,
    //   filters.end_date,
  ]);
  const [startDate, endDate] = dateRange;
  // const navigate = useNavigate();
  // const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  useEffect(() => {
    setSelectedPackage("");
    loadPackages(isIndustry);
  }, [isIndustry]);
  useEffect(() => {
    setIsCompany(null);
  }, [isIndustry]);
  const OrderHistoryColumns = [
    { name: <H4>Sl No</H4>, selector: (row) => row.Si, width: "80px" ,center:true},
    {
      name: <H4>User Name</H4>,
     selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.Id}`}
      >
        {row.UserName}
      </Link>
    ),
      sortable: true,
      wrap:true,
    },
    {
      name: <H4>Invoice No</H4>,
      id: "invoice_number",
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.Order_id}`}
        >
          {row.Invoice_no}
        </Link>
      ),
      sortable: true,
      width: "100px",
      wrap: true,
    },
    {
      name: <H4>Industry Name</H4>,
      selector: (row) => row.IndustryName,
      sortable: true,
      wrap: true,
      width: "150px",
    },
        {
            name: <H4>Company Name</H4>,
            selector: (row) => (
              <Link
                to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.company_id}&user_id=${row.Id}&industryId=${row.industryTypeId}`}
                state={{
                  clientUrl: row.client_url,
                  industryName: row.Industry,
                }}
              >
                {row.CompanyName}
              </Link>
            ),
            sortable: true,
            width: "190px",
            wrap: true,
          },
    {
      name: <H4>Packages</H4>,
      selector: (row) => row.PackageName,
      sortable: true,
    },
    {
      name: <H4>Invoice Date</H4>,
      selector: (row) => row.InvoiceDate,
      sortable: true,
    },
    {
      name: <H4>Expiry Date</H4>,
      selector: (row) => row.ExpiryDate,
      sortable: true,
    },
    {
      name: <H4>Plan Type</H4>,
      selector: (row) => row.PlanType,
      sortable: true,
    },
  ];
  const loadPackages = async (industryId) => {
    if (!industryId?.value) {
      setPackageOptions([]);
      setSelectedPackage("");
      return;
    }

    try {
      const res = await getDataWithToken(
        `${getpackageselect}?industry_type_id=${industryId.value}`,
      );
      if (res?.status === true && Array.isArray(res?.data)) {
        setPackageOptions(res.data);
      } else {
        setPackageOptions([]);
      }
    } catch (err) {
      setPackageOptions([]);
    }
  };
  const handleFilter = () => {
    const filters = {
      industry_id: isIndustry?.value || "",
      company_id: isCompany?.value || "",
      package_id: selectedPackage || "",
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
      search: searchKeyword,
    };
    setAppliedFilters(filters);
    setCurrentPage(1);
    paymentDueSubscriptionData(1, perPage, filters);
  };
const ResetFileter = () => {
  setIsCompany(null);
  setIsIndustry(null);
  setDateRange([null, null]);
  setSearchResetKey(prev => prev + 1); 
  setAppliedFilters({});
  setCurrentPage(1);
  paymentDueSubscriptionData(1, perPage, {});
};
  useEffect(() => {
    paymentDueSubscriptionData(1);
  }, []);
  const updateSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    paymentDueSubscriptionData(page, perPage);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    paymentDueSubscriptionData(page, newPerPage);
  };

  const paymentDueSubscriptionData = async (
    page = 1,
    size = perPage,
    filters = appliedFilters,
  ) => {
    try {
      setLoading(true);

      const query = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_id: filters.industry_id || "",
        package_id: filters.package_id || "",
        company_id: filters.company_id || "",
        start_date: filters.start_date || "",
        end_date: filters.end_date || "",
        user_id: "",
      }).toString();

      const res = await getDataWithToken(
        `${getPaymentDueSubscription}?${query}`,
      );

      const list = res?.data?.data || [];
      setTotalRows(res?.data?.total || 0);

      const mappedData = list.map((e, index) => ({
        Si: (page - 1) * size + index + 1,
        UserName: e.user_name,
        Invoice_no: (
          <span>
            {e.invoice_prefix} {e.invoice_number}
          </span>
        ),
        Order_id: e.order_id,
        Id:e.id,
        IndustryName: e.industry_name,
        CompanyName: e.company,
        PackageName: e.package_name,
        InvoiceDate:e.invoice_date,
        ExpiryDate: e.end_date,
        PlanType: e.plan_type,
        company_id:e.company_id,
        client_url:e.client_url,
        industryTypeId:e.industry_type_id
      }));

      setSubscriptionList(mappedData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Payment Due Subscription"
        parent="Subscription"
        title="Payment Due Subscription"
      />
      <Card>
        <CardHeader>
          <H3>Payment Due Subscription List</H3>
        </CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="5" lg="3">
                <div style={{ position: "relative" }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                    dateFormat="dd-MM-yyyy" 
                  />
                </div>
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="5" lg="3" className="form-element">
                <CompanyFilter
                  IsCompany={isCompany}
                  setIsCompany={setIsCompany}
                  industryId={isIndustry?.value}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <select
                  className="form-select"
                  value={selectedPackage}
                  disabled={!isIndustry?.value}
                    style={!isIndustry?.value ? {
                        backgroundColor: "#f5f5f5",
                        color: "#999"
                    } : {}}
                  onChange={(e) => {
                    setSelectedPackage(e.target.value);
                  }}
                >
                  <option value="">
                    {isIndustry?.value
                      ? "All Packages"
                      : "Select Industry First"}
                  </option>

                  {packageOptions.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg.name}
                    </option>
                  ))}
                </select>
              </Col>
             
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px" 
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>
                  <button
      type="button"
      className="btn btn-primary mb-2 "
      onClick={ResetFileter}
    >
      Reset
    </button>
  
                </div>
              </Col>

            </Row>
          </div>
          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={OrderHistoryColumns}
              data={subscriptionList}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              progressPending={loading}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default PaymentDueSubscriptionTable;
